import { memo } from 'react'
import BaseModal from '@/components/BaseModal/BaseModal'
import CountDown from '@/components/CountDown/CountDown'
import PaidItem from './PaidItem/PaidItem'
import PaidBundle from './PaidBundle/PaidBundle'
import ScrollList from '@/components/ScrollList/ScrollList'
// import priceReduce from '@/assets/images/price-reduce.png'
// import priceReduce2 from '@/assets/images/price-reduce-2.png'
import priceReduce3 from '@/assets/images/priceReduce3.png'
import './PayCenter.less'

// // PaidBundle 配置数据
// const PAID_BUNDLE_CONFIG_1 = {
//   title: '论文三件套',
//   list: [{ label: '开题报告 x1' }, { label: '文献综述 x1' }, { label: '毕业论文 x1' }],
//   originPrice: 151,
//   price: 119,
//   diff: 32,
//   items: [{ id: 10, count: 1 }],
//   listWidth: 415,
//   priceReduce: priceReduce2,
//   highlightLabel: '最受欢迎套餐（无限改稿）',
//   containerClassName: 'PaidBundle-container-1'
// }

// const PAID_BUNDLE_CONFIG_2 = {
//   title: '毕业七件套',
//   list: [
//     { label: '开题报告 x1' },
//     { label: '毕业论文 x1' },
//     { label: '答辩PPT x1' },
//     { label: '降重 20000字' },
//     { label: '文献综述 x1' },
//     { label: '排版格式 x1' },
//     { label: '降AIGC 20000字' }
//   ],
//   originPrice: 305,
//   price: 168,
//   diff: 137,
//   items: [{ id: 9, count: 1 }],
//   listWidth: 415,
//   priceReduce: priceReduce
// }
const PAID_BUNDLE_CONFIG_1 = {
  title: '',
  list: [{ label: '毕业论文 x1' }, { label: '降AIGC 1万字' }, { label: '排版格式 x1' }, { label: '答辩PPT x1' }],
  originPrice: 186,
  price: 128,
  diff: 58,
  items: [{ id: 11, count: 1 }],
  listWidth: 415,
  priceReduce: priceReduce3,
  highlightLabel: '省心毕业四件套 最受欢迎套餐（论文无限改稿）',
  containerClassName: 'PaidBundle-container-2'
}

const PayCenter = ({ visible, onCancel, type, quantities }: any) => {
  // 处理 type 参数，支持单个数字或数组
  const getTypeArray = () => {
    if (Array.isArray(type)) {
      return type
    }
    if (typeof type === 'number' && type > 0) {
      return [type]
    }
    return []
  }

  return (
    <BaseModal modalProps={{ open: visible, onCancel }} title={null} className='payCenterModal'>
      <div className='header-box'>
        <CountDown startText='2025毕业季钜惠 全年最低' />
        <ScrollList />
      </div>
      <div className='paycenter'>
        <PaidItem type={getTypeArray()} quantities={quantities} onCancel={onCancel} />
        <PaidBundle {...PAID_BUNDLE_CONFIG_1} />
        {/* <PaidBundle {...PAID_BUNDLE_CONFIG_2} /> */}
      </div>
    </BaseModal>
  )
}

export default memo(PayCenter)
